import { Link } from "react-router-dom";
import blogs from "../data/blogs";

export default function Blogs() {
    return (
        <main className="min-h-screen py-20">
            <div className="max-w-7xl mx-auto px-6">

                {/* 🔲 HEADING BOX (SEPARATE) */}
                <div className="bg-white/95 rounded-3xl shadow-2xl p-8 md:p-12 text-center mb-16">
                    <h1 className="text-4xl md:text-5xl font-extrabold text-[#7a0c18]">
                        हमारे ब्लॉग्स
                    </h1>
                    <p className="mt-4 text-gray-700 text-lg max-w-2xl mx-auto">
                        श्री बालाजी मसाले की ओर से मसालों और सेहत से जुड़ी जानकारी
                    </p>
                </div>

                {/* 🔲 BLOG CARDS (ALREADY SEPARATE BOXES) */}
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-12">
                    {blogs.map((blog) => (
                        <div
                            key={blog.slug}
                            className="bg-white rounded-3xl shadow-2xl overflow-hidden hover:-translate-y-1 transition"
                        >
                            <img
                                src={blog.image}
                                alt={blog.title}
                                className="w-full h-56 object-cover"
                            />

                            <div className="p-6">
                                <p className="text-sm text-gray-500">
                                    {blog.date}
                                </p>

                                <h3 className="mt-2 text-xl font-bold text-[#7a0c18]">
                                    {blog.title}
                                </h3>

                                <p className="mt-3 text-gray-700">
                                    {blog.desc}
                                </p>

                                <Link
                                    to={`/blogs/${blog.slug}`}
                                    className="mt-5 inline-block text-[#7a0c18] font-semibold hover:underline"
                                >
                                    पूरा पढ़ें →
                                </Link>
                            </div>
                        </div>
                    ))}
                </div>

            </div>
        </main>
    );
}
